export default class GenericUtils {
  static ObjectKeysLength(obj) {
    return Object.keys(obj).length;
  }

  static QueryParamsLength(queryString: string): number {
    if (!queryString) return 0;

    return queryString.match(/[a-z\d]+=[a-z\d]+/gi).length;
  }

  static async getUserIpAddress(): Promise<string> {
    const getIp = await fetch('https://api.ipify.org?format=json');
    const data = await getIp.json();

    return data['ip'] ? data['ip'] : '';
  }
}
